<div ng-controller="hostChannelController as ctrl" class="host-channel">
    <div class="modal-view">
        <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
    </div>
</div>